import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=4b88285e&scoped=true"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js"
import style0 from "./StatisticsHeader.vue?vue&type=style&index=0&id=4b88285e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88285e",
  null
  
)

export default component.exports